export const BORDERS = {
  subtle: { value: '1px solid {colors.brand.border}' },
  nav: { value: '1px solid {colors.brand.600}' },
  danger: { value: '1px solid {colors.brand.error}' },
  onboarding: { value: '1px solid {colors.neutral.200}' },
  ready: { value: '1px solid {colors.neutral.100}' },
};
